import { Stack, Typography, useTheme } from '@mui/material';

import { tPortalLib } from '../../locales';
import { PortalTheme } from '../../theme';
import { AccountBalance } from './account-balance.component';

export interface AccountInfoProps {
  id: string;
  type: 'CREDIT' | 'PREPAID' | 'DIRECT';
  balance: number | undefined;
  maxCreditLimit: number | undefined;

  localeKey: string;
  currencyFormatter: (value: number, hideZeroDecimals?: boolean) => string;
  showBalance: boolean;
  toggleBalance: () => void;
}

export const AccountInfo = (props: AccountInfoProps) => {
  const theme = useTheme<PortalTheme>();

  if (props.type === 'DIRECT') {
    return (
      <Stack mt="auto" justifyContent="end">
        <Typography variant="body2" sx={{ color: theme.card.contrastText }}>
          {tPortalLib.accountCard.direct()}
        </Typography>
      </Stack>
    );
  }

  return (
    <Stack justifyContent="start">
      <Typography
        variant="body2"
        sx={{
          color: theme.card.secondaryContrastText,
        }}
      >
        {props.type === 'CREDIT'
          ? tPortalLib.accountCard.credit()
          : tPortalLib.accountCard.balance()}
      </Typography>

      <AccountBalance
        id={props.id}
        type={props.type}
        balance={props.balance}
        maxCreditLimit={props.maxCreditLimit}
        localeKey={props.localeKey}
        currencyFormatter={props.currencyFormatter}
        showBalance={props.showBalance}
        toggleBalance={props.toggleBalance}
      />
    </Stack>
  );
};
